export default {
  namespaced: true,
  state: {
    buttonAuth: [],
    routerAuth: [],
    menuAuth: [],
  },
  actions: {
    saveButtonAuth({ commit }, val) {
      commit('UPDATE_BUTTON_AUTH', val)
    },
    saveRouterAuth({ commit }, val) {
      commit('UPDATE_ROUTER_AUTH', val)
    },
    saveMenuAuth({ commit }, val) {
      commit('UPDATE_MENU_AUTH', val)
    },
  },
  mutations: {
    UPDATE_BUTTON_AUTH(state, val) {
      state.buttonAuth = val
    },
    UPDATE_ROUTER_AUTH(state, val) {
      state.routerAuth = val
    },
    UPDATE_MENU_AUTH(state, val) {
      state.menuAuth = val
    },
  },
}
